import React, { Component } from 'react';
import './App.css'
import Signup from './signup/Signup'
import Whim from './whim/Whim'

class App extends Component {
 constructor(props) {
   super(props);
   this.state = {
     registered: false
   }
   this.handleRegisteredUser = this.handleRegisteredUser.bind(this)
 }

 handleRegisteredUser(e) {
   this.setState({
     registered: e
   })
 }

  render() {
    return (
      <div className="quick">
        <div className='logo center'>
          <img src='logo.png' alt="rappi"/>
        </div>
        { !this.state.registered &&  <Signup register={this.handleRegisteredUser.bind(this)} city={this.props.match.params.city}></Signup> }
        { this.state.registered &&  <Whim/> }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js